// extracted by mini-css-extract-plugin
export default {"main":"_713aa56b75","tit":"b0866c5c02","maintitle":"_62f5d4b4bb","ylw":"_1597d8fc0f","white":"_3e8730c386","mv_title":"feac5c1955","mv_nc":"_7ccc4f3b2e","mv_in":"_57fb464c1f"};